var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemarkMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4983_15685)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.984 0.583301C13.7262 0.235254 6.27422 0.235254 3.01641 0.583301C1.68829 0.737598 0.41524 2.01104 0.260944 3.33838C-0.0871033 6.59619 -0.0871033 9.854 0.260944 13.1118C0.41485 14.4396 1.68829 15.713 3.01602 15.8669C4.09571 15.9821 5.63594 16.0595 7.33165 16.0981C7.91407 17.0954 8.53321 18.1231 9.12657 19.1528C9.52969 19.8524 10.4703 19.8524 10.8734 19.1528C11.4668 18.1231 12.0859 17.0954 12.6684 16.0981C14.3637 16.0591 15.9039 15.9821 16.9832 15.8669C18.3109 15.713 19.5844 14.4396 19.7383 13.1118C20.0863 9.854 20.0863 6.59619 19.7383 3.33838C19.584 2.01064 18.3109 0.737207 16.9832 0.583301H16.984ZM11.5512 11.6657H5.15587C4.6379 11.6657 4.21837 11.2458 4.21837 10.7282C4.21837 10.2106 4.63829 9.79072 5.15587 9.79072H11.5512C12.0691 9.79072 12.4887 10.2106 12.4887 10.7282C12.4887 11.2458 12.0688 11.6657 11.5512 11.6657ZM14.8445 7.43838H5.15587C4.6379 7.43838 4.21837 7.01846 4.21837 6.50088C4.21837 5.9833 4.63829 5.56338 5.15587 5.56338H14.8445C15.3625 5.56338 15.782 5.9833 15.782 6.50088C15.782 7.01846 15.3621 7.43838 14.8445 7.43838Z",
    fill: "url(#paint0_linear_4983_15685)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4983_15685",
    x1: 0.00000610351,
    y1: 10.0001,
    x2: 20,
    y2: 10.0001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0080DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#49BCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#61CAFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4983_15685"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemarkMobile);
export default __webpack_public_path__ + "static/media/remark-mobile.df31bbfe9f1c00e8148c5aedbb301259.svg";
export { ForwardRef as ReactComponent };